export default __webpack_public_path__ + "static/media/Carina.cd3e7b41.svg";